import React from "react";

type PopUpErrorMessageProps = {
  isErrorModalOpen: boolean
  errMessages: string
}

const PopUpErrorMessage: React.FC<PopUpErrorMessageProps> = ({ isErrorModalOpen, errMessages }): JSX.Element => {

  return (
    <div className={`popup-error-modal ${isErrorModalOpen ? "show" : ""}`}>
      <div
        className={`message-wrapper ${isErrorModalOpen ? "fadein" : "fadeout"
          }`}
      >
        {/* <p>{errMessages.length > 0 ? `${errMessages[0]}` : ""}</p> */}
        <p>{errMessages || ""}</p>
      </div>
    </div>
  )
}

export default PopUpErrorMessage